<div class="prose">
  <h1>Dashboard</h1>
</div>

@if (fetchingCloseToExpiration) {
  <div class="mt-6 w-full text-center">
    <div class="loading loading-spinner loading-lg"></div>
  </div>
} @else {
  <div class="mt-6 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
    <div class="hover:cursor-pointer" [routerLink]="['/licenses']">
      <div
        class="prose dashboard-card-header"
      >
        <div class="flex items-center gap-2">
          <app-clipboard-icon class="h-8 w-8 text-current"></app-clipboard-icon>
          <h2 class="m-0">Licenses</h2>
        </div>
        <app-right-arrow-icon
          class="h-8 w-8 text-current"
        ></app-right-arrow-icon>
      </div>
      <div class="dashboard-card-body">
        <p>
          View all of your currently active licenses and add them to your cart
          to renew.
        </p>
        @if (hasCloseToExpiration) {
          <p class="italic text-error">
            You have licenses that are close to expiration. Click here to renew
            them before they expire.
          </p>
        }
      </div>
    </div>

    @if (hasApiSubscription) {
      <div class="hover:cursor-pointer" [routerLink]="['/api-invoices']">
        <div
          class="prose dashboard-card-header"
        >
          <div class="flex items-center gap-2">
            <app-file-invoice-icon
              class="h-8 w-8 text-current"
            ></app-file-invoice-icon>
            <h2 class="m-0">API Invoices</h2>
          </div>
          <app-right-arrow-icon
            class="h-8 w-8 text-current"
          ></app-right-arrow-icon>
        </div>
        <div class="dashboard-card-body">
          <p>View and pay for your pending API invoices.</p>
        </div>
      </div>

      <div class="hover:cursor-pointer" [routerLink]="['/api-job-logs']">
        <div
          class="prose dashboard-card-header"
        >
          <div class="flex items-center gap-2">
            <app-list-icon class="h-8 w-8 text-current"></app-list-icon>
            <h2 class="m-0">API Job Logs</h2>
          </div>
          <app-right-arrow-icon
            class="h-8 w-8 text-current"
          ></app-right-arrow-icon>
        </div>
        <div class="dashboard-card-body">
          <p>View your API job logs.</p>
        </div>
      </div>
    }
    <div class="hover:cursor-pointer" [routerLink]="['/receipts']">
      <div
        class="prose dashboard-card-header"
      >
        <div class="flex items-center gap-2">
          <app-file-invoice-icon
            class="h-8 w-8 text-current"
          ></app-file-invoice-icon>
          <h2 class="m-0">Receipts</h2>
        </div>
        <app-right-arrow-icon
          class="h-8 w-8 text-current"
        ></app-right-arrow-icon>
      </div>
      <div class="dashboard-card-body">
        <p>View your completed orders.</p>
      </div>
    </div>

    <div class="hover:cursor-pointer" [routerLink]="['/tenant/users']">
      <div
        class="prose dashboard-card-header"
      >
        <div class="flex items-center gap-2">
          <app-users-icon class="h-8 w-8 text-current"></app-users-icon>
          <h2 class="m-0">Users</h2>
        </div>
        <app-right-arrow-icon
          class="h-8 w-8 text-current"
        ></app-right-arrow-icon>
      </div>
      <div class="dashboard-card-body">
        <p>View, invite, and manage users and pending invitations.</p>
      </div>
    </div>

    <div class="hover:cursor-pointer" [routerLink]="['/saved-payment-methods']">
      <div
        class="prose dashboard-card-header"
      >
        <div class="flex items-center gap-2">
          <app-credit-card-icon
            class="h-8 w-8 text-current"
          ></app-credit-card-icon>
          <h2 class="m-0">Saved Payment Methods</h2>
        </div>
        <app-right-arrow-icon
          class="h-8 w-8 text-current"
        ></app-right-arrow-icon>
      </div>
      <div class="dashboard-card-body">
        <p>Add, edit, and delete saved payment methods.</p>
      </div>
    </div>
  </div>
}
